import AppBar from "@material-ui/core/AppBar";
import Modal from "@material-ui/core/Modal";
import { makeStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import _ from "lodash";
import React, { useState } from "react";
import { connect } from "react-redux";
import { resetMarkerKey } from "../../actions";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import NameTab from "./NameTab";
import QuestionTab from "./QuestionTab";
import { placeholder_questions } from "../../settings";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    minWidth: "90%",
    minHeight: "70%",
    maxHeight: "93%",
    overflowY: "scroll",
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(0, 0, 3),
  },
}));

const Overlay = (props) => {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [error, setError] = useState({
    message: "",
    show: false,
  });

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const validateInput = () => {
    const question = props.marker["question_en"];
    const answer = props.marker["answer"];
    let errors = false;
  
    if (!question && Object.keys(props.marker).filter(k => k.includes('question') && k !== 'question_en').length > 0) {
      errors = true;
      setError({
        message: "English is required",
        show: true,
      });
    }
    console.log(answer)
    if (question && !Array.isArray(answer)) {
      errors = true;
      setError({
        message: "Could not save answer",
        show: true,
      });
    }

    return errors;
  };

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={error.show}
        autoHideDuration={6000}
        onClose={() => setError({ message: "", show: false })}
      >
        <Alert
          onClose={() => setError({ message: "", show: false })}
          severity="warning"
        >
          {error.message}
        </Alert>
      </Snackbar>
      <Modal
        open={_.size(props.marker) > 0}
        onClose={() => {
          const errors = validateInput();
          if (!errors) props.resetMarkerKey();
        }}
      >
        <div className={classes.modal}>
          <AppBar position="static" color="default">
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              aria-label="full width tabs example"
            >
              <Tab label="Name" />
              <Tab label="Question" />
            </Tabs>
          </AppBar>
          <>
            <NameTab value={value} placeholder={props.placeholder} marker={props.marker} />
            <QuestionTab value={value} />
          </>
        </div>
      </Modal>
    </>
  );
};

const mapStateToProps = ({ events }) => {
  const { locations, key, placeholders } = events;
  const marker = locations[key] || {};
  const placeholder = placeholders[marker.key];

  return {
    locations,
    marker,
    placeholder,
  };
};

export default connect(mapStateToProps, {
  resetMarkerKey,
})(Overlay);
